<div class="channel-product-action-button--container">
  <button
    mat-icon-button
    (click)="onCreateSku(); $event.stopPropagation()"
    matTooltip="Create New Sku"
  >
    <mat-icon>add_box</mat-icon>
  </button>
  <button
    mat-icon-button
    (click)="onCreateVariantSku(); $event.stopPropagation()"
    matTooltip="Add as Variant"
  >
    <mat-icon>library_add</mat-icon>
  </button>
  <ng-container *ngIf="params?.data?.lumSkuId">
    <ng-container
      *ngIf="params?.data?.existingAlternateSku; else emptyAlternateSku"
    >
      <button
        matTooltip="Already added as Alternate SKU"
        mat-icon-button
        class="alternate-sku-button__disabled"
      >
        <mat-icon>label</mat-icon>
      </button>
    </ng-container>
    <ng-template #emptyAlternateSku>
      <button
        *ngIf="params?.data?.lumSkuId"
        mat-icon-button
        (click)="onAddAlternateSku(); $event.stopPropagation()"
        matTooltip="Add as Alternate SKU"
      >
        <mat-icon>label_outline</mat-icon>
      </button>
    </ng-template>
  </ng-container>
  <button
    *ngIf="params?.data?.appIntegrationAccount?.app !== appAccountType.EDI"
    mat-icon-button
    (click)="onPushProduct(); $event.stopPropagation()"
    matTooltip="Push Product"
  >
    <i class="fas fa-paper-plane"></i>
  </button>
  <ng-container
    *ngIf="
      hasLumSku &&
      ('utah_DV-2872_overbuffer_to_pause_a_channel_product' | featureFlag)
    "
  >
    <ng-container *ngIf="isOverBuffer; else pauseSellingProduct">
      <button
        matTooltip="Resume selling"
        mat-icon-button
        (click)="onToggleOverBuffer(); $event.stopPropagation()"
      >
        <mat-icon>play_circle_outline</mat-icon>
      </button>
    </ng-container>
    <ng-template #pauseSellingProduct>
      <button
        matTooltip="Pause selling"
        mat-icon-button
        (click)="onToggleOverBuffer(true); $event.stopPropagation()"
      >
        <mat-icon>pause_circle_outline</mat-icon>
      </button>
    </ng-template>
  </ng-container>
</div>
